<script>
export default {
    name: "InfoCardsEmptyItem"
}
</script>

<template>
    <div
        class="hidden lg:block rounded-2xl opacity-[15%] border bg-baseColor border-baseColor p-5 w-full h-full shadow-lg"></div>
</template>

<style scoped lang="scss">

</style>
